import { type ReactElement } from 'react'
import { type DashboardDataWithEditable } from '@terros/common'
import { Menu } from '@mantine/core'
import { useTranslation } from '@front/model'
import { MaterialSymbolIcon, TButton } from '@components'

type Props = {
  dashboard: DashboardDataWithEditable
  isBusy: boolean
  onDelete: (dashboard: DashboardDataWithEditable) => void
  onDuplicate: (dashboard: DashboardDataWithEditable) => void
}

/** Per-row actions. Duplicate is offered even on read-only rows — copying a shared
 *  dashboard is how a widget from it gets onto one of your own. */
export function DashboardRowMenu({ dashboard, isBusy, onDelete, onDuplicate }: Props): ReactElement {
  const { t } = useTranslation()

  return (
    <Menu position='bottom-end' shadow='md' width={220}>
      <Menu.Target>
        <TButton
          buttonType='icon-rounded'
          icon='more_vert'
          loading={isBusy}
          tooltip='Dashboard actions'
          variant='ghost'
        />
      </Menu.Target>
      <Menu.Dropdown>
        <Menu.Item
          leftSection={<MaterialSymbolIcon icon='content_copy' size='md' />}
          onClick={() => onDuplicate(dashboard)}
        >
          {t('Duplicate')}
        </Menu.Item>
        {dashboard.editable === true && (
          <Menu.Item
            color='red'
            leftSection={<MaterialSymbolIcon icon='delete' size='md' />}
            onClick={() => onDelete(dashboard)}
          >
            {t('Delete')}
          </Menu.Item>
        )}
      </Menu.Dropdown>
    </Menu>
  )
}
